import { GetStaticPropsResult } from 'next'
import React, { ReactElement } from 'react'
import { PageMeta } from 'src/pages'
import homeData from '@/content/home.json'
import { Layout } from '@/components/Layout'
import {
  ProperamentMovies,
  ProperamentMoviesProps,
} from '@/components/patterns/ProperamentMovies'
import properamentPageData from '@/content/properament.json'
import { HeroImage, HeroImageProps } from '@/components/patterns/HeroImage'
import { getMoviesBillboardIncoming } from '@/src/movies'
import {
  NewsletterSection,
  NewsletterSectionProps,
} from '@/components/patterns/NewsletterSection'

interface ProperamentPageProps {
  meta: PageMeta
  incomingMovies: ProperamentMoviesProps
  heroImage: HeroImageProps
  newsletter: NewsletterSectionProps
}

export async function getStaticProps(): Promise<
  GetStaticPropsResult<ProperamentPageProps>
> {
  const billboardData = await getMoviesBillboardIncoming()
  return {
    props: {
      meta: {
        title: properamentPageData.title,
        description: properamentPageData.subtitle,
      },
      heroImage: {
        picture: properamentPageData.picture,
      },
      incomingMovies: {
        title: properamentPageData.title || '',
        subtitle: properamentPageData.subtitle || '',
        movies: JSON.parse(billboardData),
      },
      ...homeData,
    },
  }
}

export default function ProperamentPage({
  meta,
  heroImage,
  incomingMovies,
  newsletter,
}: ProperamentPageProps): ReactElement {
  return (
    <Layout meta={meta}>
      <HeroImage {...heroImage} />
      <ProperamentMovies {...incomingMovies} />
      <NewsletterSection {...newsletter} />
    </Layout>
  )
}
